import axios from "axios";

// Detectar se está em produção (HTTPS) ou desenvolvimento
const hostname = window.location.hostname.toLowerCase();
const protocol = window.location.protocol;
const isProduction = protocol === "https:";
const isHostinger = hostname.includes("nutricaoanimalraix.com.br") || 
                    hostname.includes("nutricaoanimalraix") ||
                    hostname === "nutricaoanimalraix.com.br" ||
                    hostname === "www.nutricaoanimalraix.com.br";
const isLocalhost = hostname === "localhost" || 
                    hostname === "127.0.0.1" || 
                    hostname.startsWith("192.168.") || 
                    hostname.startsWith("10.") ||
                    hostname.startsWith("172.16.") ||
                    hostname.startsWith("172.17.") ||
                    hostname.startsWith("172.18.") ||
                    hostname.startsWith("172.19.") ||
                    hostname.startsWith("172.20.") ||
                    hostname.startsWith("172.21.") ||
                    hostname.startsWith("172.22.") ||
                    hostname.startsWith("172.23.") ||
                    hostname.startsWith("172.24.") ||
                    hostname.startsWith("172.25.") ||
                    hostname.startsWith("172.26.") ||
                    hostname.startsWith("172.27.") ||
                    hostname.startsWith("172.28.") ||
                    hostname.startsWith("172.29.") ||
                    hostname.startsWith("172.30.") ||
                    hostname.startsWith("172.31.");

// Debug: Log das informações de detecção
console.log("🔍 Detecção de ambiente:", {
  hostname: hostname,
  protocol: protocol,
  isProduction: isProduction,
  isHostinger: isHostinger,
  isLocalhost: isLocalhost,
  fullUrl: window.location.href
});

// Se estiver em produção HTTPS ou na Hostinger (e não for localhost), usar proxy PHP
// Caso contrário, usar a URL direta do backend
let API_BASE_URL;
if ((isProduction || isHostinger) && !isLocalhost) {
  // Em produção HTTPS, usar proxy PHP que faz requisições HTTP do servidor
  API_BASE_URL = "/api-proxy.php";
  console.log("🌐 Modo PRODUÇÃO detectado - usando proxy PHP:", API_BASE_URL);
} else {
  // Em desenvolvimento, usar URL direta
  API_BASE_URL = process.env.REACT_APP_API_URL || "http://31.97.24.69:4015";
  // Garante que sempre use HTTP, nunca HTTPS (múltiplas verificações)
  API_BASE_URL = API_BASE_URL.replace(/^https:\/\//i, "http://");
  if (!API_BASE_URL.startsWith("http://")) {
    API_BASE_URL = "http://" + API_BASE_URL.replace(/^\/\//, "");
  }
  console.log("🔧 Modo DESENVOLVIMENTO - usando URL direta:", API_BASE_URL);
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 segundos de timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de requisição - força HTTP sempre
api.interceptors.request.use(
  (config) => {
    // Força HTTP de forma muito agressiva
    if (config.baseURL) {
      const originalBaseURL = config.baseURL;
      config.baseURL = config.baseURL.replace(/^https:\/\//i, "http://");
      if (originalBaseURL !== config.baseURL) {
        console.warn("⚠️ FORÇANDO HTTP na baseURL:", originalBaseURL, "→", config.baseURL);
      }
    }
    if (config.url) {
      const originalURL = config.url;
      config.url = config.url.replace(/^https:\/\//i, "http://");
      if (originalURL !== config.url) {
        console.warn("⚠️ FORÇANDO HTTP na URL:", originalURL, "→", config.url);
      }
    }
    
    // Garante que a URL completa seja HTTP
    const fullUrl = (config.baseURL || "") + (config.url || "");
    if (fullUrl.includes("https://")) {
      console.error("🚨 AINDA TEM HTTPS! Forçando correção...");
      config.baseURL = (config.baseURL || "").replace(/https:\/\//gi, "http://");
      config.url = (config.url || "").replace(/https:\/\//gi, "http://");
    }
    
    // Log final para debug
    console.log("✅ Requisição FINAL configurada:", {
      baseURL: config.baseURL,
      url: config.url,
      fullURL: (config.baseURL || "") + (config.url || "")
    });
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Log da URL configurada (sempre, para debug em produção)
console.log("API Base URL configurada:", API_BASE_URL);
console.log("Verificando se é HTTP:", API_BASE_URL.startsWith("http://") ? "✓ Sim" : "✗ Não - CORRIGINDO");

// Interceptor para melhor tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log detalhado do erro
    console.error("Erro na requisição:", {
      message: error.message,
      code: error.code,
      url: error.config?.url,
      baseURL: error.config?.baseURL,
      fullURL: (error.config?.baseURL || "") + (error.config?.url || ""),
      requestURL: error.request?.responseURL || error.config?.url
    });
    
    if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
      console.error("Timeout na requisição:", error.config?.url);
    } else if (error.code === "ERR_NETWORK" || error.message.includes("ERR_CONNECTION")) {
      console.error("Erro de conexão:", error.config?.url);
      console.error("URL completa tentada:", (error.config?.baseURL || "") + (error.config?.url || ""));
      console.error("Verifique se o backend está rodando e acessível em:", error.config?.baseURL);
    } else if (error.message && error.message.includes("CORS")) {
      console.error("Erro de CORS:", error.message);
      console.error("Método:", error.config?.method?.toUpperCase());
      console.error("URL:", error.config?.url);
    }
    return Promise.reject(error);
  }
);

export default api;
